<edit-modal-layout [form]="form"
  [pageTitle]="pageTitle"
  (onCancel)="close()"
  (save)="save()"
  >

  <form novalidate
    class="flex-form"
    [formGroup]="form"
    (keydown.enter)="$event.preventDefault()">

    <mat-form-field>
      <mat-label>{{'Form' | translate}}</mat-label>
      <mat-select (selectionChange)="onChanged($event.value)" formControlName="aform" id="aform"
        [placeholder]="'Form' | translate">
        @for (f of aforms; track f) {
          <mat-option value={{f.id}}>
            {{ f.name }}
          </mat-option>
        }
      </mat-select>
      @if (form.get('aform').errors?.required) {
        <mat-error>
          {{'Form is required.' | translate}}
        </mat-error>
      }
    </mat-form-field>

  </form>

</edit-modal-layout>
